export const useSearchPlaceholderProps = ({searchResults, searchQuery, isLoading}) => {
	if (!searchQuery) return {name: 'search', title: false, animation: 'magnifying-glass'}
	if (isLoading) return {name: 'loading', title: false, animation: 'magnifying-glass'}
	if (searchQuery && searchResults.length === 0) return {name: 'no_results', title: false, animation: 'broken-egg'}
	return null
}
